var indexOf = [].indexOf;

import {
  colorPickerColors
} from 'constants/colors';

angular.module('gym.calendar').directive('editEventSeries', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_series.html.slim'),
    scope: {
      gym: '=',
      event: '=',
      classrooms: '=',
      styles: '='
    },
    controller: ["$document", "$timeout", "$scope", "$state", "$stateParams", "$modal", "$filter", "flash", "loadingAnimation", "CalendarService", "EmploymentService", "EventDefaultsService", "EditEventService", "EventService", "TrainersService", "FeatureAvailabilityService", "CalendarLastVisitedViewService", function($document, $timeout, $scope, $state, $stateParams, $modal, $filter, flash, loadingAnimation, CalendarService, EmploymentService, EventDefaultsService, EditEventService, EventService, TrainersService, FeatureAvailabilityService, CalendarLastVisitedViewService) {
      var base, base1, base2, base3, convertToArray, getDailySession, reloadEventTypes, setDailySession, showSessionsExistMessage, startMoment;
      $document.scrollTop(0);
      $scope.permissions = EmploymentService.get().permissions;
      if (!$scope.permissions.manage_events) {
        $state.go('gym.dashboard');
      }
      $scope.attendanceFeatureAvailable = FeatureAvailabilityService.isAvailable('attendance');
      $scope.editNotAvailable = !EventService.isEditAvailable($scope.event);
      if ($scope.editNotAvailable) {
        EventService.showEditNotAvailableAlert($scope.event);
      }
      // timepicker config
      $scope.minuteStep = 5;
      $scope.trainers = TrainersService.get();
      $scope.unableToManageOtherContacts = !$scope.permissions.manage_other_contacts;
      $scope.eventRepeatIntervalUnits = EditEventService.getEventRepeatIntervalUnits();
      $scope.restrictCancellationsUnits = EditEventService.getRestrictCancellationsUnits();
      $scope.eventColors = colorPickerColors;
      $scope.days = EditEventService.getDays();
      $scope.isCustomColorSelected = function() {
        var ref;
        return $scope.event.color && (ref = $scope.event.color, indexOf.call($scope.eventColors, ref) < 0);
      };
      startMoment = moment($scope.event.start_at, 'YYYY/MM/DD HH:mm');
      $scope.event.start_date = startMoment.format('YYYY-MM-DD');
      $scope.event.start_time = startMoment;
      $scope.event.end_time = moment($scope.event.end_at, 'YYYY/MM/DD HH:mm');
      if ($scope.isCustomColorSelected()) {
        $scope.event.customColor = $scope.event.color;
      }
      if ($scope.event.repeat_until) {
        $scope.event.repeat_until = moment($scope.event.repeat_until).tz($scope.gym.tz).toDate();
      }
      $scope.isRepeating = function() {
        return !!$scope.event.repeats || !!$scope.event.repeat_until || !!$scope.event.infinite;
      };
      $scope.event.edit_type = (function() {
        switch (false) {
          case !!$scope.isRepeating():
            return 'single';
          case $scope.event.repeat_number !== 1:
            return 'all';
          default:
            return 'future';
        }
      })();
      $scope.displayEditDailySessionRestrictionDetails = function() {
        return $modal.open({
          template: require('templates/gyms/calendar/events/daily_session_edit_restriction_details.html.slim'),
          controller: 'DailySessionEditRestrictionDetailsCtrl',
          resolve: {
            event: function() {
              return $scope.event;
            }
          }
        });
      };
      $scope.event.repeat_type = (function() {
        switch (false) {
          case !$scope.event.repeat_until:
            return 'until';
          case !$scope.event.infinite:
            return 'infinite';
          default:
            return 'count';
        }
      })();
      (base = $scope.event).cancel_before_number || (base.cancel_before_number = 1);
      (base1 = $scope.event).cancel_before_unit || (base1.cancel_before_unit = 'day');
      (base2 = $scope.event).bookings_allowed_before_number || (base2.bookings_allowed_before_number = 1);
      (base3 = $scope.event).bookings_allowed_before_unit || (base3.bookings_allowed_before_unit = 'day');
      $scope.prevStartDate = $scope.event.start_date;
      $scope.copyDailySessionWdays = $scope.days.map(function(day, index) {
        if (index < 6) {
          return [index + 1];
        } else {
          return [0];
        }
      });
      $scope.displayCopyWdays = function(days) {
        return days.map(function(day) {
          return $filter('capitalize')($scope.days[day]);
        }).join(', ');
      };
      $scope.isCopyDaySelected = function(dayIndex, copyDay) {
        return EditEventService.isCopyDaySelected(dayIndex, copyDay, $scope.copyDailySessionWdays);
      };
      $scope.toggleCopyDay = function(dayIndex, copyDayIndex) {
        return EditEventService.toggleCopyDay(dayIndex, copyDayIndex, $scope.copyDailySessionWdays);
      };
      $scope.copySession = function(day) {
        return EditEventService.copySession($scope.event, day, $scope.copyDailySessionWdays);
      };
      $scope.setColor = function(color) {
        $scope.event.color = color;
        return $scope.event.customColor = void 0;
      };
      $scope.$on('colorpicker-closed', function(currentScope, color) {
        return $timeout(function() {
          return $scope.event.color = color.value;
        });
      });
      $scope.toggleDay = function(index) {
        return EditEventService.toggleDay($scope.event, index);
      };
      $scope.addDailySession = function(index) {
        return $scope.event.daily_sessions[index].push(getDailySession());
      };
      $scope.removeSession = function(dayIndex, sessionIndex) {
        $scope.event.daily_sessions[dayIndex].splice(sessionIndex, 1);
        if (!$scope.event.daily_sessions[dayIndex].length) {
          return $scope.toggleDay(dayIndex);
        }
      };
      $scope.isDaySelected = function(index) {
        return EditEventService.isDaySelected($scope.event, index);
      };
      $scope.onIntervalUnitChanged = function() {
        EditEventService.onIntervalUnitChanged($scope.event);
        if ($scope.event.repeat_interval_unit === 'week') {
          return $scope.prevStartDate = $scope.event.start_date;
        }
      };
      $scope.onEndDateChanged = function() {
        if ($scope.event.repeat_interval_unit === 'week') {
          $scope.event.repeat_type = 'until';
          return $scope.repeatTypeChanged();
        }
      };
      $scope.onStartTimeChanged = function() {
        if (!moment($scope.event.start_time).isValid()) {
          return $scope.event.start_time = moment().toDate();
        }
      };
      $scope.onEndTimeChanged = function() {
        if (!moment($scope.event.end_time).isValid()) {
          return $scope.event.end_time = moment().toDate();
        }
      };
      setDailySession = function(day) {
        return EditEventService.setDailySession($scope.event, day);
      };
      getDailySession = function(startTime = $scope.event.start_time) {
        return EditEventService.getDailySession($scope.event, startTime);
      };
      $scope.onDailySessionStartTimeChanged = function(session, day) {
        return EditEventService.onDailySessionStartTimeChanged(session);
      };
      $scope.onDailySessionEndTimeChanged = function(session, day) {
        return EditEventService.onDailySessionEndTimeChanged(session);
      };
      $scope.parseDailySession = function(session) {
        if (session.start_at && session.end_at) {
          session.start_at_obj = moment(session.start_at, 'h:mma').toDate();
          return session.end_at_obj = moment(session.end_at, 'h:mma').toDate();
        }
      };
      $scope.onDateChanged = function() {
        var day, prevDailySession, prevDay, ref, ref1;
        if ($scope.event.multiple_sessions_per_day) {
          day = $scope.eventDay();
          prevDay = moment($scope.prevStartDate).day();
          prevDailySession = $scope.event.daily_sessions[prevDay] || [getDailySession()];
          if (((ref = $scope.event.edit_type) === 'future' || ref === 'all') && ((ref1 = $scope.event.daily_sessions[day]) != null ? ref1.length : void 0)) {
            return showSessionsExistMessage();
          } else {
            $scope.event.wdays = _.chain($scope.event.wdays).without(prevDay).union([day]).uniq().value();
            $scope.event.daily_sessions[prevDay] = void 0;
            $scope.event.daily_sessions[day] = prevDailySession;
            return $scope.prevStartDate = $scope.event.start_date;
          }
        }
      };
      $scope.onWaitlistToggle = function() {
        if (!$scope.event.waitlist_enabled) {
          return $scope.event.waitlist_limit = void 0;
        }
      };
      $scope.eventDay = function() {
        return moment($scope.event.start_date).day();
      };
      showSessionsExistMessage = function() {
        var date;
        date = moment($scope.event.start_date).format('DD MMM YYYY');
        return window.alert(`Sessions already exist for this series on ${date}. Please manage your session times directly in the \"Days of the Week\" section at the bottom of the page.`);
      };
      $scope.sessionsLabel = function() {
        var date;
        if ($scope.event.edit_type === 'single') {
          date = moment($scope.event.start_date).format('dddd, D MMMM');
          return `Sessions for ${date}`;
        } else {
          return 'Days of the week';
        }
      };
      $scope.onRepeatsChanged = function() {
        $scope.event.repeat_type = 'count';
        return $scope.repeatTypeChanged();
      };
      $scope.onEndDateChanged = function() {
        $scope.event.repeat_type = 'until';
        return $scope.repeatTypeChanged();
      };
      $scope.repeatTypeChanged = function() {
        return EditEventService.repeatTypeChanged($scope.event);
      };
      $scope.isParticipantLimitValid = function() {
        return EditEventService.isParticipantLimitValid($scope.event);
      };
      $scope.isFormReady = function() {
        return !$scope.isLoading && ($scope.event.repeat_interval_unit !== 'week' || !$scope.isRepeating() || EditEventService.isWeeklyEventReady($scope.event));
      };
      $scope.cancel = function() {
        if (window.confirm("Are you sure you want to navigate away? All unsaved changes will be lost.")) {
          return $state.go(CalendarLastVisitedViewService.get());
        }
      };
      $scope.save = function() {
        var hasSessionTimeError, temp_bookings_allowed_before_number, temp_bookings_allowed_before_unit;
        $scope.event.start_time_array = convertToArray($scope.event.start_time, $scope.event.start_date);
        $scope.event.end_time_array = convertToArray($scope.event.end_time, $scope.event.start_date);
        hasSessionTimeError = _.find($scope.event.daily_sessions, function(day) {
          return _.find(day, function(session) {
            return moment(session.start_at, 'h:mma').isSameOrAfter(moment(session.end_at, 'h:mma'));
          });
        });
        if (hasSessionTimeError) {
          flash.error = "Event end time must be after start time";
          return;
        }
        if (!$scope.event.restrict_cancellations) {
          $scope.event.cancel_before_number = void 0;
          $scope.event.cancel_before_unit = void 0;
        }
        if (!$scope.event.restrict_bookings_before) {
          temp_bookings_allowed_before_number = $scope.event.bookings_allowed_before_number;
          temp_bookings_allowed_before_unit = $scope.event.bookings_allowed_before_unit;
          $scope.event.bookings_allowed_before_number = void 0;
          $scope.event.bookings_allowed_before_unit = void 0;
        }
        loadingAnimation.show();
        $scope.isLoading = true;
        return $scope.event.save().then(function(model) {
          $state.go(CalendarLastVisitedViewService.get());
          return loadingAnimation.hide();
        }, function(response) {
          var defaultError;
          $document.scrollTop(0);
          defaultError = 'Update failed. Please fix the errors below';
          flash.error = response.data.error || defaultError;
          $scope.event.errors = response.data.errors;
          loadingAnimation.hide();
          $scope.isLoading = false;
          $scope.event.bookings_allowed_before_number = temp_bookings_allowed_before_number;
          return $scope.event.bookings_allowed_before_unit = temp_bookings_allowed_before_unit;
        });
      };
      convertToArray = function(time, date) {
        var x, y;
        x = moment(time).toArray();
        y = moment(date).toArray();
        return [y[0], y[1] + 1, y[2], x[3], x[4]];
      };
      $scope.deleteEvent = function() {
        return CalendarService.deleteEvent($scope, $scope.event);
      };
      reloadEventTypes = function() {
        return EventService.eventTypesWithDeleted($scope.event.event_type_id).then(function(types) {
          $scope.eventTypes = types;
          return $scope.eventTypes.unshift({
            name: 'Select a type'
          });
        });
      };
      reloadEventTypes();
      $scope.manageTypes = function() {
        return EditEventService.manageTypes($scope.eventTypes).result.then(function() {
          return reloadEventTypes();
        }, function() {
          return reloadEventTypes();
        });
      };
      $scope.manageLocations = function() {
        return EditEventService.manageLocations($scope.classrooms).result.then(function() {
          return $scope.classrooms.reload();
        }, function() {
          return $scope.classrooms.reload();
        });
      };
      $scope.displayRequireActiveMembershipDescription = function() {
        return EventService.displayRequireActiveMembershipDescription();
      };
      $scope.displayProximityCheckinDescription = function() {
        return EventService.displayProximityCheckinDescription();
      };
      return $scope.publicEventTooltipContent = EventService.publicEventTooltip();
    }]
  };
});
